/**
 *
 * MeetingSlot
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/media/Avatar/index.jsx';
import MeetingStatus from './MeetingStatus.jsx';

function MeetingSlot(props) {
  const { meeting, showStudent } = props; // Can be used without studentId to show all all children
  const { student, set } = meeting.details;

  return (
    <div className="d-flex">
      {showStudent && <Avatar className="me-3" src={student.avatar} />}
      <div>
        {showStudent ? (
          <>
            <h3 className="mt-0 mb-2">{student.displayName}</h3>
            <div className="mb-2">{set.title}</div>
          </>
        ) : (
          <h3 className="mt-0 mb-2">{set.title}</h3>
        )}
        <div className="text-muted small mb-3">{set.description}</div>
        <MeetingStatus meeting={meeting} />
      </div>
    </div>
  );
}

MeetingSlot.propTypes = {
  meeting: PropTypes.object,
  showStudent: PropTypes.bool,
};

export default MeetingSlot;
